<template>
  <div :class="['dialog', { visible: visible }]">
    <div class="title">在售商品</div>
    <div class="closeBtn" @click="visible = false"></div>
    <div class="content">
      <a-tabs v-model="currentTab">
        <a-tab-pane :key="1" tab="大宗商品">
          <div class="list">
            <div v-for="item in listB" :key="item.id" class="list-item">
              <div class="cover">
                <img :src="item.url || require('@/img/datav/productImg.png')" alt="" />
              </div>
              <div class="name two-line">{{ item.name }}</div>
            </div>
          </div>
          <a-pagination
            v-model="pageB.current"
            :page-size="pageB.size"
            :total="pageB.total"
            show-less-items
            @change="onChange"
          />
        </a-tab-pane>
        <a-tab-pane :key="2" tab="零售商品">
          <div class="list">
            <div v-for="item in listC" :key="item.id" class="list-item">
              <div class="cover">
                <img :src="item.url || require('@/img/datav/productImg.png')" alt="" />
              </div>
              <div class="name two-line">{{ item.name }}</div>
            </div>
          </div>
          <a-pagination
            v-model="pageC.current"
            :page-size="pageC.size"
            :total="pageC.total"
            show-less-items
            @change="onChange"
          />
        </a-tab-pane>
        <a-tab-pane :key="3" tab="校园餐商品">
          <div class="list">
            <div v-for="item in listS" :key="item.id" class="list-item">
              <div class="cover">
                <img :src="item.imgName || require('@/img/datav/productImg.png')" alt="" />
              </div>
              <div class="name two-line">{{ item.materialName }}</div>
            </div>
          </div>
          <a-pagination
            v-model="pageS.current"
            :page-size="pageS.size"
            :total="pageS.total"
            show-less-items
            @change="onChange"
          />
        </a-tab-pane>
      </a-tabs>
    </div>
  </div>
</template>
<script>
import { onsaleMaterailPage, groupMaterialPage } from '@/api/dashboard'
import to from 'await-to'
export default {
  name: 'Product',
  data() {
    return {
      visible: false,
      currentTab: 1,
      listB: [],
      listC: [],
      listS: [],
      pageB: {
        current: 1,
        size: 27,
        total: 0,
      },
      pageC: {
        current: 1,
        size: 27,
        total: 0,
      },
      pageS: {
        current: 1,
        size: 27,
        total: 0,
      },
    }
  },
  methods: {
    show() {
      this.visible = true
      this.initData(1)
      this.initData(2)
      this.initDataSchool()
    },
    close() {
      this.visible = false
    },
    async initData(apply) {
      let current
      let size
      if (apply == 1) {
        current = this.pageB.current
        size = this.pageB.size
      }
      if (apply == 2) {
        current = this.pageC.current
        size = this.pageC.size
      }
      const [res, err] = await to(onsaleMaterailPage({ current, size, apply }))
      if (err) return
      if (apply == 1) {
        this.listB = res.data.list
        this.pageB.total = res.data.total
      }
      if (apply == 2) {
        this.listC = res.data.list
        this.pageC.total = res.data.total
      }
    },
    async initDataSchool(apply) {
      const [res, err] = await to(
        groupMaterialPage({ current: this.pageS.current, size: this.pageS.size, apply }),
      )
      if (err) return
      this.listS = res.data.list
      this.pageS.total = res.data.total
    },
    onChange(current) {
      if (this.currentTab == 1) {
        this.pageB.current = current
        this.initData(1)
      }
      if (this.currentTab == 2) {
        this.pageC.current = current
        this.initData(2)
      }
      if (this.currentTab == 3) {
        this.pageS.current = current
        this.initDataSchool()
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.dialog {
  z-index: 99999999;
  width: 3212px !important;
  height: 1564px !important;
  background: url('~@/img/datav/dialog_bg.png');
  background-size: 100% 100%;
  position: absolute;
  left: 329px;
  top: 423px;
  display: none;

  ::v-deep .ant-tabs {
    height: 100%;

    .ant-tabs-nav .ant-tabs-tab {
      font-size: 40px;
      color: #e8e8e8;

      &.ant-tabs-tab-active {
        color: #40a9ff;
      }
    }
  }

  .title {
    font-size: 57px;
    text-align: center;
    line-height: 107px;
    margin-bottom: 24px;
  }

  .closeBtn {
    cursor: pointer;
    width: 58px;
    height: 58px;
    position: absolute;
    right: 40px;
    top: 34px;
    background: url('~@/img/datav/dialog_close_btn.png');
    background-size: 100% 100%;
  }

  .content {
    padding: 0 194px;
    height: calc(100% - 200px);

    .list {
      display: flex;
      flex-wrap: wrap;

      .list-item {
        width: 263px;
        height: 327px;
        margin-right: 46px;
        margin-bottom: 54px;
        padding: 21px 26px 19px;
        box-sizing: border-box;
        background: linear-gradient(180deg, rgba(20, 95, 163, 0.41), rgba(23, 77, 168, 0.24));

        &:nth-of-type(9n) {
          margin-right: 0;
        }

        .cover {
          width: 210px;
          height: 210px;
          margin-bottom: 18px;

          img {
            width: 100%;
            height: 100%;
          }
        }

        .name {
          font-weight: normal;
          font-size: 24px;
          color: #ffffff;
          height: 58px;
          line-height: 30px;
        }
      }
    }

    ::v-deep .ant-pagination {
      position: absolute;
      bottom: 60px;
      left: 0;
      width: 100%;
      text-align: center;
      padding-top: 33px;

      > li {
        width: 58px;
        height: 58px;
        box-sizing: border-box;
        border: 2px solid #46639a;
        font-weight: normal;
        font-size: 24px;
        line-height: 54px;
        text-align: center;
        background-color: transparent;
        margin: 0 10px;

        .ant-pagination-item-link {
          background-color: transparent;
          border: 0;
        }

        a {
          color: #46629a;
        }

        &.ant-pagination-item-active {
          background-color: #46629a;

          a {
            color: #fff;
          }
        }
      }
    }
  }

  &.visible {
    display: block;
    animation: anim-open 0.5s ease;
  }

  @keyframes anim-open {
    0% {
      transform: scale(0);
    }

    100% {
      transform: scale(1);
    }
  }
}
</style>
